module.exports = __webpack_public_path__ + "img/profile_default.4f8aa382.svg";